var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 93,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 114.5,
    cy: 46.5,
    r: 46.5,
    fill: "#65C96E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B1E3B6",
    strokeWidth: 10,
    d: "M80 47H0"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYxIiBoZWlnaHQ9IjkzIiB2aWV3Qm94PSIwIDAgMTYxIDkzIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIG9wYWNpdHk9IjAuNSIgY3g9IjExNC41IiBjeT0iNDYuNSIgcj0iNDYuNSIgZmlsbD0iIzY1Qzk2RSIvPgo8bGluZSB4MT0iODAiIHkxPSI0NyIgeDI9Ii00LjM3MTE0ZS0wNyIgeTI9IjQ3IiBzdHJva2U9IiNCMUUzQjYiIHN0cm9rZS13aWR0aD0iMTAiLz4KPC9zdmc+Cg==";
export { SvgHeadline as ReactComponent };